import React, { useState, useEffect } from 'react';
import onetApiService from '../services/onetApiService';
import OnetAttribution from '../components/OnetAttribution';

const OnetTest = () => {
  const [testResults, setTestResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const testOnetApi = async () => {
    setLoading(true);
    setError(null);
    setTestResults(null);

    try {
      console.log('Testing O*NET API...');
      
      // Test 1: Search for occupations
      console.log('Test 1: Searching for occupations...');
      const searchResult = await onetApiService.searchOccupations('software developer', 5);
      console.log('Search result:', searchResult);

      // Test 2: Get occupation details (using a common SOC code)
      console.log('Test 2: Getting occupation details...');
      const detailsResult = await onetApiService.getOccupationDetails('15-1132'); // Software Developers, Applications
      console.log('Details result:', detailsResult);

      // Test 3: Get occupation categories
      console.log('Test 3: Getting occupation categories...');
      const categoriesResult = await onetApiService.getOccupationCategories();
      console.log('Categories result:', categoriesResult);

      setTestResults({
        search: searchResult,
        details: detailsResult,
        categories: categoriesResult,
        timestamp: new Date().toISOString()
      });

    } catch (err) {
      console.error('O*NET API test error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      padding: '20px', 
      backgroundColor: '#f0f0f0',
      minHeight: '100vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{ color: '#333', marginBottom: '20px' }}>O*NET API Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <button 
          onClick={testOnetApi}
          disabled={loading}
          style={{
            padding: '10px 20px',
            backgroundColor: loading ? '#ccc' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontSize: '16px'
          }}
        >
          {loading ? 'Testing...' : 'Test O*NET API'}
        </button>
      </div>

      {error && (
        <div style={{ 
          padding: '10px', 
          backgroundColor: '#f8d7da', 
          color: '#721c24', 
          border: '1px solid #f5c6cb',
          borderRadius: '5px',
          marginBottom: '20px'
        }}>
          <strong>Error:</strong> {error}
        </div>
      )}

      {testResults && (
        <div style={{ 
          padding: '15px', 
          backgroundColor: '#d4edda', 
          color: '#155724', 
          border: '1px solid #c3e6cb',
          borderRadius: '5px',
          marginBottom: '20px'
        }}>
          <h3 style={{ marginTop: 0 }}>Test Results (Success!)</h3>
          <p><strong>Timestamp:</strong> {testResults.timestamp}</p>
          <p><strong>Search API:</strong> {testResults.search.success ? '✅ Working' : '❌ Failed'}</p>
          <p><strong>Details API:</strong> {testResults.details.success ? '✅ Working' : '❌ Failed'}</p>
          <p><strong>Categories API:</strong> {testResults.categories.success ? '✅ Working' : '❌ Failed'}</p>
        </div>
      )}

      <div style={{ 
        padding: '15px', 
        backgroundColor: '#e0e0e0', 
        borderRadius: '5px',
        marginBottom: '20px'
      }}>
        <h3 style={{ marginTop: 0 }}>API Configuration</h3>
        <p><strong>Client ID:</strong> {import.meta.env.VITE_ONET_CLIENT_ID || 'careerlift_skillbind (default)'}</p>
        <p><strong>API Key:</strong> {import.meta.env.VITE_ONET_API_KEY ? 'Set' : 'Using default fallback'}</p>
        <p><strong>Base URL:</strong> /api/onet (proxy)</p>
      </div>

      <div style={{ 
        padding: '15px', 
        backgroundColor: '#fff3cd', 
        color: '#856404', 
        border: '1px solid #ffeaa7',
        borderRadius: '5px'
      }}>
        <h3 style={{ marginTop: 0 }}>Test Details</h3>
        <p>This test will:</p>
        <ul>
          <li>Search for "software developer" occupations</li>
          <li>Get details for SOC code 15-1132 (Software Developers, Applications)</li>
          <li>Fetch occupation categories</li>
        </ul>
        <p><strong>Note:</strong> Check the browser console for detailed API responses.</p>
      </div>

      {/* O*NET Attribution */}
      <OnetAttribution showBorder={true} />
    </div>
  );
};

export default OnetTest;
